module.exports = __webpack_public_path__ + "img/des-action-tree.c73cd985.png";